import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux'
import configureStore from './store'
import { verifyCredentials } from './authentication/javascripts/redux-token-auth-config'
import App from './App';

let reactData = { app_env: 'development' }
const store = configureStore(reactData)
verifyCredentials(store)

// Load initial state
// store.dispatch(loadInitialData(reactData.gameId));

const initApp = (
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
)

ReactDOM.render(initApp, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js